import React, { useEffect } from "react";
import NotificationManager, { NotificationToast } from "./NotificationManager";
import NotificationsDetails from "./NotificationsDetails";

export const NotificationContainer: React.FunctionComponent = () => {
  const [state, setState] = React.useState<{ notifications: NotificationToast[] }>({
    notifications: [],
  });

  useEffect(() => {
    NotificationManager.addChangeListener(handleStoreChange);
    return () => {
      NotificationManager.removeChangeListener(handleStoreChange);
    };
  }, []);

  function handleStoreChange(notifications) {
    setState({
      notifications,
    });
  }

  function handleRequestHide(notification: NotificationToast) {
    notification.onClose?.();
    NotificationManager.remove(notification.key);
  }

  return <NotificationsDetails notifications={state.notifications} onRequestHide={handleRequestHide} />;
};

export default NotificationContainer;
